module.exports = __webpack_public_path__ + "static/media/lines.d786a105.svg";